<template>
    <div>
        <b-img
            v-if="imageUrl"
            class="configured-img"
            :src="imageUrl"
            :alt="vehicleName"
        />
        <body-style-icon v-else :id="bodyStyleOrDefault" />
    </div>
</template>

<style lang="scss" scoped>
.configured-img {
    max-width: 250px;
}
i {
    font-size: 5rem;
    padding: 50px 0;
    display: block;
}
</style>

<script>
import _ from "lodash";
import TrimDetailsMixin from "../mixins/TrimDetailsMixin";
import BodyStyleIcon from "Components/BodyStyleIcon";

export default {
    name: "TrimImage",
    components: { BodyStyleIcon },
    mixins: [TrimDetailsMixin],

    props: {
        trim: {
            type: Object,
            required: true
        },
        transparent: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        imageUrl() {
            if (_.isNil(this.trim.transparentProfileImageUrl)) {
                return null;
            }

            if (!this.transparent) {
                return this.trim.profileImageUrl;
            }

            return this.trim.transparentProfileImageUrl;
        }
    }
};
</script>
